import {RequestAnfrage} from "../../model/request.anfrage";

/**
 * Class holds all the data of the request inside the moderat that the user needs for the frontend.
 */
export class ModeratAnfrage implements RequestAnfrage {

  /**
   * the three different paths on this advisors
   */
  public static readonly PATH_EXPLO = "explo";
  public static readonly PATH_SPEZI = "spezi";

  /**
   * paths of the moc. either the user comes from wpchech or starts inside the moc
   */
  static readonly MODE_STANDARD = '';
  static readonly MODE_WPCHECK = 'wpcheck';

  /**
   * holds the last update we did on the local data
   */
  lastupdate: number;

  /**
   * Holds the last (location) path that the user has seen.
   */
  lastPath: string;

  /**
   * the main interest
   */
  interesse: string = null;

  /**
   * list of measures if interes is 'massnahme'
   */
  interesseMassnahmen: string = "";

  /**
   * Input of the first chapter
   */
  verbrauchsanalyseInput: any = {};

  /**
   * The calculated result for the first chapter
   */
  verbrauchsanalyseResult: any = {};

  /**
   * Input of the second chapter
   */
  bestandsanalyseInput: any = {};

  /**
   * List of extra fields that are requested in some partner portals.
   */
  extraFields: any = {};

  /**
   * Selected measures on the meeasure page
   */
  massnahmen: any = {};

  /**
   * Holds the selected equity for the user
   */
  eigenkapital: number = 0;

  /**
   * result of the user's dialog registration
   */
  dialogResult: string;

  /**
   * did the user opens the contact list
   */
  hasContactsShown: boolean;

  /**
   * toggle to force recalculation of the measures.
   */
  recalculateMeasures: boolean = false;

  /**
   * Holds the result from the measure calculation
   */
  measureResult: any;

  /**
   * holds the currecnty active portalId for this request
   */
  portalId: string;

  /**
   * Holds the campaignid which is used by tracking or external partners
   */
  campaignId: string = null;

  /**
   * path in logic
   */
  mode: string = ModeratAnfrage.MODE_STANDARD;

  /**
   * Returns the user path ion the advisor, based on its first selection
   */
  getPath(): string {
    if(this.interesse === 'massnahme') {
      return ModeratAnfrage.PATH_SPEZI;
    }
    return ModeratAnfrage.PATH_EXPLO;
  }
}
